<pagination-template #p="paginationApi" (pageChange)="onPageChange($event)">
  <div class="custom-pagination">
    <div class="page-button pagination-previous left-arrow">
      <div (click)="onPrev(p)" class="page-button-content">
        <txtb-icons type="backArrow"></txtb-icons>
      </div>
    </div>
    <div
      *ngFor="let page of p.pages"
      [class.current]="p.getCurrent() === page.value"
      class="page-button page-number"
      [class.dots]="page.label === '...'"
    >
      <span
        (click)="p.setCurrent(page.value)"
        *ngIf="p.getCurrent() !== page.value"
        class="page-button-content"
        >{{ page.label }}</span
      >
      <div *ngIf="p.getCurrent() === page.value">
        <span>{{ page.label }}</span>
      </div>
    </div>
    <div class="page-button pagination-next right-arrow">
      <div (click)="onNext(p)" class="page-button-content">
        <txtb-icons type="backArrow"></txtb-icons>
      </div>
    </div>
  </div>
</pagination-template>
